import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import cls from 'classnames/bind';

import noop from 'lodash/noop';

import declOfNum from '@ott/utility-decl-of-num';

import styles from './PriceNights.scss';

const cx = cls.bind(styles);

const AVAILABLE_NIGHTS = [3, 7, 11, 14];

class PriceNights extends PureComponent {
  static propTypes = {
    onNightsChange: PropTypes.func,
  };

  static defaultProps = {
    onNightsChange: noop,
  };

  renderItem = (nights, i) => {
    const { nights: selectedNights, onNightsChange } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={cx('item', {
          'item--isActive': nights === selectedNights,
        })}
        onClick={() => onNightsChange(nights)}
        key={i}
      >
        {nights} {declOfNum(nights, ['ночь', 'ночи', 'ночей'])}
      </div>
    );
  };

  render() {
    const { className } = this.props;

    return (
      <div className={cx('PriceNights', className)}>{AVAILABLE_NIGHTS.map(this.renderItem)}</div>
    );
  }
}

export default PriceNights;
